import { useState, useEffect, useCallback } from 'react';
import { hospitalApi } from '../../hospitalApi';

function printInvoice(inv, info) {
  const fmtR = (n) => '₹' + Number(n || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  const subtotal = (Number(inv.consult_fee) + Number(inv.medicine_charges) + Number(inv.lab_charges) + Number(inv.other_charges) - Number(inv.discount)) || 0;
  const h = info || {};
  const html = `<!DOCTYPE html><html><head><meta charset="utf-8">
<title>Invoice ${inv.invoice_no}</title>
<style>
  * { box-sizing: border-box; margin: 0; padding: 0; }
  body { font-family: Arial, sans-serif; font-size: 13px; color: #222; padding: 32px; max-width: 700px; margin: auto; }
  .hospital-name { font-size: 22px; font-weight: 800; color: #1b6ca8; }
  .hospital-sub { font-size: 12px; color: #555; margin-top: 3px; }
  .divider { border: none; border-top: 2px solid #1b6ca8; margin: 14px 0; }
  .divider-thin { border: none; border-top: 1px solid #ddd; margin: 10px 0; }
  .invoice-title { font-size: 16px; font-weight: 700; text-align: center; letter-spacing: 2px; margin: 10px 0; color: #1b6ca8; }
  .meta-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 4px 20px; margin: 10px 0; }
  .meta-grid .lbl { font-size: 11px; color: #777; }
  .meta-grid .val { font-weight: 600; }
  table { width: 100%; border-collapse: collapse; margin: 12px 0; }
  th { background: #e8f4fd; color: #1b6ca8; font-size: 12px; font-weight: 700; padding: 7px 10px; text-align: left; }
  td { padding: 7px 10px; border-bottom: 1px solid #f0f0f0; }
  .amount { text-align: right; }
  .total-row { font-weight: 800; font-size: 15px; color: #27ae60; background: #e6f4ea; }
  .total-row td { padding: 9px 10px; }
  .paid-badge { display: inline-block; padding: 4px 12px; border-radius: 6px; font-weight: 700; font-size: 12px; }
  .paid { background: #e6f4ea; color: #27ae60; }
  .pending { background: #fce8e6; color: #c5221f; }
  .footer-note { font-size: 11px; color: #999; text-align: center; margin-top: 20px; }
  @media print {
    body { padding: 0; }
    button { display: none; }
  }
</style></head><body>
<div style="display:flex;justify-content:space-between;align-items:flex-start">
  <div>
    <div class="hospital-name">${h.hospital_name || 'Hospital'}</div>
    <div class="hospital-sub">${[h.address, h.phone, h.email].filter(Boolean).join(' | ')}</div>
    ${h.license_no ? `<div class="hospital-sub">License: ${h.license_no}${h.gst_no ? ' | GST: ' + h.gst_no : ''}</div>` : ''}
  </div>
  <div style="text-align:right">
    <div class="paid-badge ${inv.status === 'paid' ? 'paid' : 'pending'}">${(inv.status || '').toUpperCase()}</div>
  </div>
</div>
${h.bill_header ? `<div style="font-size:12px;color:#555;margin-top:6px">${h.bill_header}</div>` : ''}
<hr class="divider">
<div class="invoice-title">TAX INVOICE</div>
<div class="meta-grid">
  <div><div class="lbl">Invoice No</div><div class="val">${inv.invoice_no || '—'}</div></div>
  <div><div class="lbl">Invoice Date</div><div class="val">${inv.invoice_date || '—'}</div></div>
  <div><div class="lbl">Patient</div><div class="val">${inv.patient_name || '—'}</div></div>
  <div><div class="lbl">Doctor</div><div class="val">${inv.doctor_name ? 'Dr. ' + inv.doctor_name : '—'}</div></div>
</div>
<hr class="divider-thin">
<table>
  <thead><tr><th>Particulars</th><th class="amount">Amount</th></tr></thead>
  <tbody>
    ${Number(inv.consult_fee) > 0 ? `<tr><td>Consultation Fee</td><td class="amount">${fmtR(inv.consult_fee)}</td></tr>` : ''}
    ${Number(inv.medicine_charges) > 0 ? `<tr><td>Medicine Charges</td><td class="amount">${fmtR(inv.medicine_charges)}</td></tr>` : ''}
    ${Number(inv.lab_charges) > 0 ? `<tr><td>Lab Charges</td><td class="amount">${fmtR(inv.lab_charges)}</td></tr>` : ''}
    ${Number(inv.other_charges) > 0 ? `<tr><td>Other Charges</td><td class="amount">${fmtR(inv.other_charges)}</td></tr>` : ''}
    ${Number(inv.discount) > 0 ? `<tr><td>Discount</td><td class="amount" style="color:#c0392b">− ${fmtR(inv.discount)}</td></tr>` : ''}
    <tr style="background:#fafafa"><td style="font-weight:600">Subtotal</td><td class="amount" style="font-weight:600">${fmtR(subtotal)}</td></tr>
    ${Number(inv.tax_pct) > 0 ? `<tr><td>Tax (${inv.tax_pct}%)</td><td class="amount">${fmtR(inv.tax_amount)}</td></tr>` : ''}
  </tbody>
  <tfoot>
    <tr class="total-row"><td>TOTAL</td><td class="amount">${fmtR(inv.total)}</td></tr>
  </tfoot>
</table>
${inv.status === 'paid' ? `
<div style="margin:10px 0;font-size:13px">
  <strong>Payment:</strong> ${fmtR(inv.paid_amount)} via ${(inv.payment_mode || '').toUpperCase()}
</div>` : ''}
${inv.notes ? `<div style="margin-top:10px;font-size:12px;color:#555"><strong>Notes:</strong> ${inv.notes}</div>` : ''}
${h.bill_footer ? `<div style="font-size:12px;color:#555;margin-top:10px;border-top:1px solid #eee;padding-top:10px">${h.bill_footer}</div>` : ''}
<div class="footer-note">This is a computer-generated invoice and does not require a signature.</div>
<div style="text-align:center;margin-top:10px">
  <button onclick="window.print()" style="padding:8px 24px;background:#1b6ca8;color:#fff;border:none;border-radius:6px;font-size:14px;cursor:pointer">🖨 Print</button>
</div>
</body></html>`;
  const w = window.open('', '_blank');
  w.document.write(html);
  w.document.close();
  w.focus();
  setTimeout(() => w.print(), 400);
}

const C = '#1b6ca8';
const DARK = '#0f4c75';
const LIGHT = '#e8f4fd';

const fmtRs = (n) => '₹' + Number(n || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

const EMPTY = {
  patientId: '', doctorId: '', invoiceDate: '',
  consultFee: '', medicineCharges: '', labCharges: '',
  otherCharges: '', discount: '', taxPct: '0', notes: '',
};

const inp = { className: 'form-control' };

function F({ label, children }) {
  return (
    <div className="form-group">
      <label className="form-label">{label}</label>
      {children}
    </div>
  );
}

function InvoiceCard({ inv, onPay, onDelete, role, C, DARK, LIGHT, fmtRs, hospitalInfo }) {
  const [expanded, setExpanded] = useState(false);
  const [showPay, setShowPay]   = useState(false);
  const [payForm, setPayForm]   = useState({ paidAmount: inv.total || '', paymentMode: 'cash' });
  const [paying, setPaying]     = useState(false);

  const handlePay = async () => {
    setPaying(true);
    await onPay(inv.id, payForm);
    setPaying(false);
    setShowPay(false);
  };

  return (
    <div style={{ background: '#fff', borderRadius: 10, boxShadow: '0 1px 6px rgba(0,0,0,.08)',
      marginBottom: 10, overflow: 'hidden',
      borderLeft: `4px solid ${inv.status === 'paid' ? '#27ae60' : '#e67e22'}` }}>
      <div style={{ padding: '12px 16px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 12 }}
        onClick={() => setExpanded(!expanded)}>
        <div style={{ flex: 1 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 2 }}>
            <div style={{ fontWeight: 700, fontSize: 14, color: DARK }}>{inv.patient_name || '—'}</div>
            <div style={{ fontWeight: 800, fontSize: 15, color: '#27ae60' }}>{fmtRs(inv.total)}</div>
          </div>
          <div style={{ fontSize: 11, color: '#5f6368' }}>
            {inv.invoice_no} · {inv.invoice_date} · Dr. {inv.doctor_name || '—'}
          </div>
        </div>
        <span style={{
          background: inv.status === 'paid' ? '#e6f4ea' : '#fef3c7',
          color: inv.status === 'paid' ? '#27ae60' : '#e67e22',
          borderRadius: 6, padding: '3px 10px', fontSize: 12, fontWeight: 700
        }}>{inv.status}</span>
        <span style={{ color: '#9aa0a6', fontSize: 14 }}>{expanded ? '▲' : '▼'}</span>
      </div>

      {expanded && (
        <div style={{ padding: '0 16px 14px', borderTop: '1px solid #f1f3f4' }}>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(150px, 1fr))', gap: 8, marginTop: 10 }}>
            {[
              ['Consult Fee', fmtRs(inv.consult_fee)],
              ['Medicine', fmtRs(inv.medicine_charges)],
              ['Lab', fmtRs(inv.lab_charges)],
              ['Other', fmtRs(inv.other_charges)],
              ['Discount', fmtRs(inv.discount)],
              ['Tax (' + (inv.tax_pct || 0) + '%)', fmtRs(inv.tax_amount)],
            ].map(([label, val]) => (
              <div key={label} style={{ background: LIGHT, borderRadius: 6, padding: '8px 10px' }}>
                <div style={{ fontSize: 11, color: '#5f6368' }}>{label}</div>
                <div style={{ fontWeight: 700, fontSize: 13, color: DARK }}>{val}</div>
              </div>
            ))}
          </div>
          {inv.notes && <div style={{ fontSize: 12, color: '#5f6368', marginTop: 8 }}>Notes: {inv.notes}</div>}
          <div style={{ display: 'flex', gap: 8, marginTop: 12 }}>
            {inv.status === 'pending' && (
              <button className="btn btn-primary" style={{ fontSize: 12, padding: '5px 14px' }}
                onClick={() => setShowPay(!showPay)}>
                💳 Pay Now
              </button>
            )}
            <button style={{ fontSize: 12, padding: '5px 14px', background: LIGHT,
              color: DARK, border: `1px solid ${C}`, borderRadius: 6, cursor: 'pointer', fontWeight: 600 }}
              onClick={() => printInvoice(inv, hospitalInfo)}>🖨 Print</button>
            {role === 'admin' && (
              <button style={{ fontSize: 12, padding: '5px 14px', background: '#fce8e6',
                color: '#c5221f', border: '1px solid #f5c6c6', borderRadius: 6, cursor: 'pointer', fontWeight: 600 }}
                onClick={() => onDelete(inv.id)}>Delete</button>
            )}
          </div>
          {showPay && (
            <div style={{ marginTop: 12, padding: 12, background: LIGHT, borderRadius: 8 }}>
              <div style={{ display: 'flex', gap: 10, alignItems: 'flex-end' }}>
                <div className="form-group" style={{ margin: 0 }}>
                  <label className="form-label" style={{ fontSize: 12 }}>Amount Paid</label>
                  <input className="form-control" type="number" min={0}
                    value={payForm.paidAmount}
                    onChange={e => setPayForm(f => ({ ...f, paidAmount: e.target.value }))} />
                </div>
                <div className="form-group" style={{ margin: 0 }}>
                  <label className="form-label" style={{ fontSize: 12 }}>Payment Mode</label>
                  <select className="form-control" value={payForm.paymentMode}
                    onChange={e => setPayForm(f => ({ ...f, paymentMode: e.target.value }))}>
                    <option value="cash">Cash</option>
                    <option value="card">Card</option>
                    <option value="upi">UPI</option>
                    <option value="netbanking">Net Banking</option>
                    <option value="cheque">Cheque</option>
                  </select>
                </div>
                <button className="btn btn-primary" style={{ fontSize: 13 }} onClick={handlePay} disabled={paying}>
                  {paying ? 'Processing…' : '✓ Confirm Payment'}
                </button>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default function HospitalBilling({ role }) {
  const [tab, setTab]           = useState('pending');
  const [invoices, setInvoices] = useState([]);
  const [patients, setPatients] = useState([]);
  const [doctors, setDoctors]   = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm]         = useState(EMPTY);
  const [saving, setSaving]     = useState(false);
  const [err, setErr]           = useState('');
  const [hospitalInfo, setHospitalInfo] = useState({});

  const load = useCallback(() => {
    const status = tab === 'pending' ? 'pending' : '';
    hospitalApi.getInvoices(status).then(d => { if (d) setInvoices(d); });
  }, [tab]);

  useEffect(() => { load(); }, [load]);
  useEffect(() => {
    hospitalApi.getPatients().then(d => { if (d) setPatients(d); });
    hospitalApi.getDoctors().then(d => { if (d) setDoctors(d.filter(doc => doc.status === 'active')); });
    hospitalApi.getInfo().then(d => { if (d) setHospitalInfo(d); });
  }, []);

  const subtotal = () => {
    const cf = parseFloat(form.consultFee) || 0;
    const mc = parseFloat(form.medicineCharges) || 0;
    const lc = parseFloat(form.labCharges) || 0;
    const oc = parseFloat(form.otherCharges) || 0;
    const dc = parseFloat(form.discount) || 0;
    return cf + mc + lc + oc - dc;
  };
  const taxAmt = () => subtotal() * (parseFloat(form.taxPct) || 0) / 100;
  const totalAmt = () => subtotal() + taxAmt();

  const handleSave = async () => {
    if (!form.patientId) { setErr('Patient is required'); return; }
    setSaving(true); setErr('');
    try {
      const today = new Date().toISOString().split('T')[0];
      const payload = {
        ...form,
        invoiceDate: form.invoiceDate || today,
        patientId: parseInt(form.patientId),
        doctorId: parseInt(form.doctorId) || undefined,
        consultFee: parseFloat(form.consultFee) || 0,
        medicineCharges: parseFloat(form.medicineCharges) || 0,
        labCharges: parseFloat(form.labCharges) || 0,
        otherCharges: parseFloat(form.otherCharges) || 0,
        discount: parseFloat(form.discount) || 0,
        taxPct: parseFloat(form.taxPct) || 0,
      };
      await hospitalApi.createInvoice(payload);
      load();
      setShowForm(false);
      setForm(EMPTY);
    } catch (e) { setErr(e.message); }
    finally { setSaving(false); }
  };

  const handlePay = async (id, payData) => {
    await hospitalApi.payInvoice(id, { paidAmount: parseFloat(payData.paidAmount) || 0, paymentMode: payData.paymentMode });
    load();
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Delete this invoice?')) return;
    await hospitalApi.deleteInvoice(id);
    load();
  };

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
        <div className="tabs" style={{ marginBottom: 0 }}>
          {[
            { key: 'pending', label: '⏳ Pending Bills' },
            { key: 'all', label: '📋 All Invoices' },
          ].map(t => (
            <button key={t.key} className={`tab${tab === t.key ? ' active' : ''}`} onClick={() => setTab(t.key)}>
              {t.label}
            </button>
          ))}
        </div>
        <button className="btn btn-primary" onClick={() => { setForm(EMPTY); setErr(''); setShowForm(!showForm); }}>
          {showForm ? '✕ Cancel' : '+ New Invoice'}
        </button>
      </div>

      {/* New Invoice Form */}
      {showForm && (
        <div className="card" style={{ marginBottom: 16 }}>
          <div className="card-header">
            <div className="card-title">Create New Invoice</div>
          </div>
          <div className="card-body">
            {err && <div style={{ color: '#c5221f', background: '#fce8e6', borderRadius: 8, padding: '8px 12px', marginBottom: 14, fontSize: 13 }}>⚠️ {err}</div>}
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: 12 }}>
              <F label="Patient *">
                <select {...inp} value={form.patientId} onChange={e => setForm(f => ({ ...f, patientId: e.target.value }))}>
                  <option value="">Select Patient</option>
                  {patients.map(p => <option key={p.id} value={String(p.id)}>{p.name}</option>)}
                </select>
              </F>
              <F label="Doctor">
                <select {...inp} value={form.doctorId} onChange={e => setForm(f => ({ ...f, doctorId: e.target.value }))}>
                  <option value="">Select Doctor</option>
                  {doctors.map(d => <option key={d.id} value={String(d.id)}>Dr. {d.name}</option>)}
                </select>
              </F>
              <F label="Invoice Date">
                <input {...inp} type="date" value={form.invoiceDate} onChange={e => setForm(f => ({ ...f, invoiceDate: e.target.value }))} />
              </F>
              <F label="Consult Fee (₹)">
                <input {...inp} type="number" min={0} value={form.consultFee} onChange={e => setForm(f => ({ ...f, consultFee: e.target.value }))} />
              </F>
              <F label="Medicine Charges (₹)">
                <input {...inp} type="number" min={0} value={form.medicineCharges} onChange={e => setForm(f => ({ ...f, medicineCharges: e.target.value }))} />
              </F>
              <F label="Lab Charges (₹)">
                <input {...inp} type="number" min={0} value={form.labCharges} onChange={e => setForm(f => ({ ...f, labCharges: e.target.value }))} />
              </F>
              <F label="Other Charges (₹)">
                <input {...inp} type="number" min={0} value={form.otherCharges} onChange={e => setForm(f => ({ ...f, otherCharges: e.target.value }))} />
              </F>
              <F label="Discount (₹)">
                <input {...inp} type="number" min={0} value={form.discount} onChange={e => setForm(f => ({ ...f, discount: e.target.value }))} />
              </F>
              <F label="Tax (%)">
                <input {...inp} type="number" min={0} max={100} step={0.5} value={form.taxPct} onChange={e => setForm(f => ({ ...f, taxPct: e.target.value }))} />
              </F>
              <div className="form-group" style={{ gridColumn: '1/-1' }}>
                <label className="form-label">Notes</label>
                <textarea {...inp} rows={2} value={form.notes} onChange={e => setForm(f => ({ ...f, notes: e.target.value }))} style={{ resize: 'vertical' }} />
              </div>
            </div>

            {/* Live total preview */}
            <div style={{ marginTop: 12, padding: 14, background: LIGHT, borderRadius: 8, display: 'flex', gap: 24, flexWrap: 'wrap' }}>
              <div>
                <div style={{ fontSize: 11, color: '#5f6368' }}>Subtotal</div>
                <div style={{ fontWeight: 700, color: DARK, fontSize: 15 }}>{fmtRs(subtotal())}</div>
              </div>
              <div>
                <div style={{ fontSize: 11, color: '#5f6368' }}>Tax ({form.taxPct || 0}%)</div>
                <div style={{ fontWeight: 700, color: '#e67e22', fontSize: 15 }}>{fmtRs(taxAmt())}</div>
              </div>
              <div>
                <div style={{ fontSize: 11, color: '#5f6368' }}>Total</div>
                <div style={{ fontWeight: 800, color: '#27ae60', fontSize: 18 }}>{fmtRs(totalAmt())}</div>
              </div>
            </div>

            <div style={{ marginTop: 16, display: 'flex', gap: 10 }}>
              <button className="btn btn-primary" onClick={handleSave} disabled={saving}>
                {saving ? 'Saving…' : '💾 Create Invoice'}
              </button>
              <button style={{ padding: '8px 18px', borderRadius: 8, border: '1px solid #e8eaed',
                background: '#fff', cursor: 'pointer', fontSize: 13 }}
                onClick={() => setShowForm(false)}>Cancel</button>
            </div>
          </div>
        </div>
      )}

      {/* Invoice list */}
      {invoices.length === 0 ? (
        <div style={{ padding: 32, textAlign: 'center', color: '#9aa0a6', background: '#fff',
          borderRadius: 10, boxShadow: '0 1px 6px rgba(0,0,0,.08)' }}>
          No invoices found
        </div>
      ) : (
        invoices.map(inv => (
          <InvoiceCard key={inv.id} inv={inv} onPay={handlePay} onDelete={handleDelete}
            role={role} C={C} DARK={DARK} LIGHT={LIGHT} fmtRs={fmtRs} hospitalInfo={hospitalInfo} />
        ))
      )}
    </div>
  );
}
